<ul>
    <li *ngFor="let note of noteList, let i = index" [class.active]="i === selected" class="note" (click)="changeValue(note)">{{note.title}}</li>
</ul>